import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/connect_24.svg.ts
import { svg } from "lit";
var connect24Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_6716_6319)">
    <path d="M9.88806 13.057C10.3415 13.6639 10.9201 14.166 11.5845 14.5294C12.2489 14.8928 12.9836 15.1088 13.7388 15.163C14.494 15.2171 15.2519 15.108 15.9613 14.8432C16.6706 14.5783 17.3148 14.1638 17.85 13.6278L21.0179 10.4568C21.9797 9.45997 22.5119 8.12494 22.4998 6.73919C22.4878 5.35345 21.9325 4.02788 20.9536 3.04798C19.9747 2.06807 18.6504 1.51224 17.2661 1.5002C15.8817 1.48816 14.548 2.02087 13.5523 2.9836L11.736 4.79111" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.112 10.9432C13.6585 10.3363 13.0799 9.83417 12.4155 9.47081C11.7511 9.10745 11.0164 8.89137 10.2612 8.83723C9.50607 8.7831 8.74811 8.89216 8.03875 9.15704C7.3294 9.42191 6.68525 9.8364 6.15 10.3724L2.98211 13.5435C2.02035 14.5402 1.48817 15.8753 1.5002 17.261C1.51223 18.6468 2.0675 19.9723 3.04642 20.9522C4.02534 21.9321 5.34959 22.488 6.73394 22.5C8.11829 22.512 9.45199 21.9793 10.4478 21.0166L12.2535 19.2091" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_6716_6319">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;
export {
  connect24Svg
};
//# sourceMappingURL=connect_24.svg-B72L67KC.js.map
